module.exports = __webpack_public_path__ + "img/pannelTwoIcon.1010568d.png";